import { useSelector } from 'react-redux';
import Img from '../common/Img.react';
var PageBanner = function PageBanner(_ref) {
  var filename = _ref.filename,
    altTag = _ref.altTag;
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "article-hero"
  }, /*#__PURE__*/React.createElement(Img, {
    src: "".concat(bucket, "/").concat(filename),
    alt: altTag
  }));
};
export default PageBanner;